import axiosInstance from './axiosInstance';

const getInviteByLeagueId = async (id) => {
  const response = await axiosInstance.get(`/invite/league/${id}`);
  return response.data;
};

const acceptInvite = async (leagueId, inviteToken) => {
  const response = await axiosInstance.post(`/invite/league/${leagueId}/${inviteToken}`);
  return response.data;
};

const checkInviteToken = async (inviteToken) => {
  const response = await axiosInstance.get(`/invite/check/${inviteToken}`);
  return response.data;
};

export default { getInviteByLeagueId, acceptInvite, checkInviteToken };